











import Vue from 'vue';
import StoriesItem from "~/stories_widget/models/StoriesItem"
import {PropType} from "vue";
import {mapGetters} from "vuex";
import {WidgetStoriesOptions} from "~/stories_widget/models/WidgetStoriesOptions";

interface StylesObject {
    [key: string]: string
}


const StoryCardItemFavoriteCells = Vue.extend({
    name: 'StoryCardItemFavoriteCells',
    props: {
        StoriesItem: {
            type: Object as PropType<StoriesItem>,
            required: true
        }
    },

    computed: {
        ...mapGetters('shared', {
            favoriteLoadedStories: 'favoriteLoadedStories',
            storiesStyle:           'storiesStyle',
        }),
        // allow video to
        images() {
            // в зависимости от размера ячейки или всегда 4 ?
            return this.favoriteLoadedStories.map((item: StoriesItem) => item.imageSrc).slice(0, 4);
        },

        favoriteImageStyle() {
            let styles = {
                paddingTop: this.storiesStyle === WidgetStoriesOptions.STYLE_RECTANGLE ? '125%' : '100%',
            };
            return styles;
        }



    },






});
export default StoryCardItemFavoriteCells;

